<template>
  <div class="BlockList" v-show="floagb">
    <div class="BlockList-W">
      <div class="signimg">
        <img
          class="imgblack"
          @click="black"
          src="../../../assets/pc/Login/black.png"
        />
        <img
          class="imgs"
          src="../../../assets/pc/Login/close.png"
          @click="close"
        />
      </div>
      <!-- <img class="imgs" src="../../../assets/pc/Login/close.png" @click="close" /> -->
      <div class="logintit">Sign up</div>
      <div class="loginbox">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="putext">
            <el-form-item prop="email">
              <el-input
                v-model="form.email"
                class="inpttext"
                placeholder="Email"
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext" style="display: flex">
            <el-form-item prop="code">
              <el-input
                v-model="form.code"
                class="inpttext"
                placeholder="Verification code"
              ></el-input>
            </el-form-item>
            <div class="lines"></div>
            <div
              class="diaojis"
              @click="startCountdown"
              :disabled="countdown > 0"
            >
            {{ countdown > 0 ? countdown + "s" : "Send" }}
            </div>
          </div>
          <div class="putext">
            <el-form-item prop="code">
              <el-input
                v-model="form.password"
                type="password"
                show-password
                class="inpttext"
                placeholder="Password"
              ></el-input>
            </el-form-item>
          </div>
          <div class="logins" @click="submit">Sign up</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SendEmail,GetRegister } from "@/assets/server/api";

export default {
  props: ["flog", "flogb"],
  data() {
    return {
      countdown: 0,
      floag: this.flog,
      floagb: this.flogb, //注册
      form: {
        email: "",
        code: "",
        password:"",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    flog(val) {
     // console.log(val);
      this.floag = val;
    },
    flogb(val) {
     // console.log(val);
      this.floagb = val;
    },
  },
  methods: {
    black() {
      this.floag = true;
      this.$emit("loginflog", this.floag);
      this.floagb = false;
      this.$emit("signups", this.floagb);
    },
    close() {
      this.floag = false;
      this.$emit("loginflog", this.floag);
      this.floagb = false;
      this.$emit("signups", this.floagb);
      //this.$emit("loginflog", this.floagb);
    },
    startCountdown() {
      this.send();
      if (this.sendtrue == true) {
        //   console.log("我发送了");
        // if (this.countdown === 0) {
        //   // Start the countdown only if it's not already running
        //   this.countdown = 60;
        //   this.countdownTimer = setInterval(() => {
        //     if (this.countdown > 0) {
        //       this.countdown--;
        //     } else {
        //       clearInterval(this.countdownTimer);
        //     }
        //   }, 1000);
        //   // Simulate sending the verification code
        // }
      }
    },
    async send() {
      //   console.log("点击发送邮件");
      if (this.form.email !== "") {
        const params = {
          email: this.form.email,
        };
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await SendEmail(formData);
        // console.log(data);
        if (data.code == 200) {
          this.sendtrue = true;
          this.flog1 = true;
          this.flog = false;
          this.emails = data.result;
          if (this.countdown === 0) {
            // Start the countdown only if it's not already running
            this.countdown = 60;
            this.countdownTimer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--;
              } else {
                clearInterval(this.countdownTimer);
              }
            }, 1000);

            // Simulate sending the verification code
          }
        } else if (data.code == 400) {
          this.countdown = 0;
          this.sendtrue = false;
          this.$message(data.result);
        }
      } else {
        this.$message(" This email are not filled in ");
        return false;
      }
    },
    async submit() {
      
      this.$refs.form.validate(async (success) => {
      // console.log(this.form);
        if (success) {
          const params = {
            email: this.form.email,
            password: this.form.password,
            code: this.form.code,
          };
          const formData = new FormData();
          const item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetRegister(formData);
      //    console.log(data);
          // this.$message(data.result);
          if (data.code == 200) {
            this.$message('registered successfully');
            this.floagb=false;
            this.emails = data.result;
          } else if (data.code == 400) {
            this.$message(" Verification code is incorrect ");
            //return false;
          }
        } else {
          this.$message(" This field are not filled in ");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 650px;
    height: 750px;
    background: #202020;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .signimg {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .imgblack {
        width: 36px;
        height: 36px;
        margin-left: 24px;
        cursor: pointer;
      }
      .imgs {
        width: 36px;
        height: 36px;
        margin-right: 24px;
        cursor: pointer;
      }
    }

    .logintit {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      line-height: 33px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 10px;
    }
    .loginbox {
      width: 530px;
      margin: 0 auto;
      margin-top: 20px;
      .putext {
        .lines{
          height: 42px;
          background: #151515;
          border: 1px solid #5b5b5b;
          position: absolute;
          right: 180px;
          margin-top: 30px;
        }
        .diaojis {
          position: absolute;
          right: 60px;
          margin-top: 20px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 30px;
          color: #ffffff;
        }
        /deep/.el-input__inner {
          border: none;
          background: #202020;
          border-bottom: 1px solid #5b5b5b;
          padding-bottom: 10px;
          padding-left: 0px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 28px;
          color: rgba(255, 255, 255, 0.3);
          color: #fff;
          border-radius: 0px !important;
          width: 530px;
          padding-left: 12px;
        }
        /deep/.el-input__inner::placeholder {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 28px;
          color: rgba(255, 255, 255, 0.3);
          border-radius: 0px !important;
        }
      }
      .logins {
        width: 530px;
        height: 76px;
        background: #3cf6f0;
        border-radius: 162px 162px 162px 162px;

        text-align: center;
        line-height: 76px;
        margin-top: 120px;
        cursor: pointer;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #151515;
      }
    }
  }
}
</style>
